<!-- <po-loading-overlay  [hidden]="isHideLoading" ></po-loading-overlay> -->
<h3>Consulta financeira</h3>

<hr />

<form #f="ngForm">
  <div class="po-row">
    <po-widget class="po-md-12 po-lg-4 po-mt-2" p-title="Total à vencer" p-primary="true">
      <div class="po-font-subtitle po-text-center">{{ this.avencer }}</div>
      <div class="po-text-center"></div>
    </po-widget>

    <po-widget class="po-md-12 po-lg-4 po-mt-2" p-title="Total vencidos">
      <div class="po-font-subtitle po-text-center">{{ this.vencidos }}</div>
      <div class="po-text-center"></div>
    </po-widget>

    <div class="po-md-5 po-lg-4 po-mt-2 .no-print">
      <po-button class="po-md-5 po-lg-4 po-mt-2 .no-print" p-icon="po-icon po-icon-print" p-label="Imprimir"
        (p-click)="printPage()"></po-button>
      <po-button class="po-md-5 po-lg-4 po-mt-2 .no-print" p-icon="po-icon po-icon-print" p-label="Gerar Planilha"
        (p-click)="geraExcel()"></po-button>
    </div>
  </div>

  <po-container class="po-m-2">
    <h3 style="color: darkgreen">Titulos à vencer</h3>
    <po-table p-sort="true" p-container="light" [p-columns]="columns" [p-items]="listAVencer" p-container="shadow"
      p-hide-text-overflow="true" p-height="300" p-striped="true">
    </po-table>
    <h3 style="color: crimson">Titulos vencidos</h3>
    <po-table p-sort="true" p-container="light" [p-columns]="columns" [p-items]="listVencidos" p-container="shadow"
      p-hide-text-overflow="true" p-height="300" p-striped="true">
    </po-table>
  </po-container>
</form>